// extracted by mini-css-extract-plugin
export var bubble = "_3n-0";
export var container = "_3n-f";
export var contrastBorder = "_3n-g";
export var greyOut = "_3n-2";
export var initialsColor0 = "_3n-3";
export var initialsColor1 = "_3n-4";
export var initialsColor10 = "_3n-d";
export var initialsColor11 = "_3n-e";
export var initialsColor2 = "_3n-5";
export var initialsColor3 = "_3n-6";
export var initialsColor4 = "_3n-7";
export var initialsColor5 = "_3n-8";
export var initialsColor6 = "_3n-9";
export var initialsColor7 = "_3n-a";
export var initialsColor8 = "_3n-b";
export var initialsColor9 = "_3n-c";
export var initialsWrapper = "_3n-1";
export var large = "_3n-l";
export var medium = "_3n-k";
export var mediumSmall = "_3n-j";
export var mediumSmallMedium = "_3n-o";
export var micro = "_3n-h";
export var small = "_3n-i";
export var tiny = "_3n-n";
export var xTiny = "_3n-m";